<template>
  <div @mousemove="mouseMove">
    <!-- <div v-if="loading" class="w-full">
      <FullScreeenLoader />
    </div> -->
    <div class="overflow-hidden">
      <div class="navbar-wrapper">
        <Navbar
          :is-white="false"
          :is-dark="true"
          @mouseover="
            setCursor(null, null, {
              'font-size': '14px',
              cursor: 'unset',
              'z-index': '1',
              width: '25px',
              height: '25px',
              opacity: 0.7,
            })
          "
        />
      </div>

      <div class="lg:relative">
        <Bubbles
          v-if="width > 1024"
          :key="width"
          class="w-full !absolute top-0"
          :height="getHeight"
          :start-width="700"
          :start-height="0"
          :set-cursor="setCursor"
          ref-prop="canvasArticles"
        />
        <div class="w-full pt-28 lg:pt-32 pointer-events-none">
          <div
            class="flex justify-start lg:justify-center pointer-events-none lg:px-6"
          >
            <div class="max-w-7xl pointer-events-none relative overflow-hidden">
              <div class="pb-12 lg:pb-24 px-0 sm:px-6 pointer-events-none">
                <AnimateTitle :title="$t('blog.title')" />
              </div>
              <div class="w-full flex justify-center">
                <BubbleText
                  class="relative spaces-bubbletext pointer-events-none w-full !px-0"
                  :set-cursor="() => {}"
                >
                  <div class="">
                    <div class="bubble-text pointer-events-none">
                      <ArticleFeatured
                        v-if="actionListData"
                        :featured-item="actionListData"
                        :set-cursor="setCursor"
                      />
                    </div>
                  </div>
                </BubbleText>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-center mt-0 lg:mt-48 px-6"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div
          class="max-w-7xl mb-8 md:mb-14 flex gap-2 w-full sm:flex-wrap items-center"
        >
          <input
            id="fname"
            v-model="value"
            type="search"
            :placeholder="$t('Search')"
            class="bg-transparent border rounded-full border-black px-6 py-1.5 md:py-3 w-auto md:w-52 lg:w-unset min-w-0 xs:min-w-[auto]"
            name="fname"
            @search="search"
            @keyup="search"
          />

          <select
            v-if="width < 500"
            v-model="activeFilter"
            class="bg-transparent border rounded-full border-black px-4 py-2 text-sm"
          >
            <option value="">{{ $t("articleType") }}</option>
            <option :value="$t('Inverviews')">{{ $t("Inverviews") }}</option>
            <option :value="$t('Articles')">{{ $t("Articles") }}</option>
            <option :value="$t('Coverage')">{{ $t("Coverage") }}</option>
            <option :value="$t('News')">{{ $t("News") }}</option>
          </select>

          <template v-if="width > 500">
            <button
              :class="{ 'active-tag': activeFilter === $t('Inverviews') }"
              class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-5 py-2.5 text-sm !font-normal"
              @click="
                pageLimit = 10;
                activeFilter =
                  activeFilter !== $t('Inverviews') ? $t('Inverviews') : '';
              "
            >
              {{ $t("Inverviews") }}
            </button>
            <button
              :class="{ 'active-tag': activeFilter === $t('Articles') }"
              class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm !font-normal"
              @click="
                pageLimit = 10;
                activeFilter =
                  activeFilter !== $t('Articles') ? $t('Articles') : '';
              "
            >
              {{ $t("Articles") }}
            </button>
            <button
              :class="{ 'active-tag': activeFilter === $t('Coverage') }"
              class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm !font-normal"
              @click="
                pageLimit = 10;
                activeFilter =
                  activeFilter !== $t('Coverage') ? $t('Coverage') : '';
              "
            >
              {{ $t("Coverage") }}
            </button>
            <button
              :class="{ 'active-tag': activeFilter === $t('News') }"
              class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm !font-normal"
              @click="
                pageLimit = 10;
                activeFilter = activeFilter !== $t('News') ? $t('News') : '';
              "
            >
              {{ $t("News") }}
            </button>
            <button
              :class="{ 'active-tag': pageLimit === 1000 }"
              class="lg:ml-auto pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm !font-normal"
              @click="
                pageLimit = 1000;
                getData();
                activeFilter = '';
              "
            >
              {{ $t("allArticles") }}
            </button>
          </template>
        </div>
      </div>

      <div class="lg:flex justify-center px-6">
        <div class="max-w-7xl w-full">
          <div
            class="lg:flex justify-center"
            @mouseenter="
              setCursor(null, null, {
                'font-size': '14px',
                background: '#FFC800',
                width: '25px',
                height: '25px',
                'z-index': '-1',
              })
            "
          >
            <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 gap-12">
              <ArticleCard
                v-for="article in activeFilter === ''
                  ? parsedPostsData.filter((a) => a.id !== actionListData?.id)
                  : parsedPostsData"
                :key="article?.id"
                :set-cursor="setCursor"
                :article="article"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="hasNextPage" class="text-center mt-12">
        <button
          class="pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-6 py-3 text-sm !font-normal"
          @click="
            currentPage++;
            getData();
          "
        >
          {{ $t("moreArticles") }}
        </button>
      </div>

      <PartnersWrapper class="pt-20 lg:pt-36" :set-cursor="setCursor" />

      <BecomeMember :set-cursor="setCursor" />
      <Footer :set-cursor="setCursor" />

      <div
        id="cursor"
        class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
        :style="cursorStyle"
        :class="{
          smallCursor: cursor === null,
        }"
        @click="cursorOnClick"
        v-html="cursor"
      ></div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import BubbleText from "~/components/Hero/BubbleText.vue";
import ArticleFeatured from "~/components/ArticleFeatured.vue";

export default {
  name: "Articles",
  components: { ArticleFeatured, BubbleText },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    useHeadMeta({
      title: t("blog.meta.title"),
      description: t("blog.meta.description"),
      url: route.fullPath,
      csUrl: 'cs/blog',
      enUrl: 'en/blog',
      image:
        "https://www.opero.cz/img/Opero_networking_propojovani_kontakty_clenstvi.jpg",
    });
  },
  data() {
    return {
      imageList: [
        "/img/1_Opero_prostor_k_pronajmu_konference_praha_1_design.jpg",
        "/img/2_Opero_eventspace_venkovni_prostor_pronajem_centrum_prahy.jpg",
        "/img/3_Opero_event_firemni_vecirek_reprezentativni_atraktivni_prostredi_praha.jpg",
        "/img/4_Opero_eventspace_pronajem_prostor_svatba_praha1_staromestska_radnice.jpg",
        "/img/5_Opero_prostor_k_pronajmu_akce_pro_150_osob_praha_1_nejkrasnejsi-min.jpg",
        "/img/6_Opero_Prague1_event_rent_conference_workshop_business_meeting_most_beautiful_space.jpg",
      ],
      currentImage: 0,
      currentImage2: 0,
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
      variables: { limit: 5 },
      featuredItemData: null,
      loading: false,
      parsedPostsData: [],
      activeFilter: "",
      value: "",
      timeout: null,
      searchQuery: "",
      actionListData: null,
      pageLimit: 10,
      currentPage: 1,
      hasNextPage: false,
    };
  },
  computed: {
    getHeight() {
      if (this.width > 1320) return 720;
      return this.width - 600;

      // if (this.width > 1350) return 1000;
      // if (this.width > 1150) return 800;

      // return this.width - 400;
    },
  },
  watch: {
    activeFilter() {
      this.getData();
    },
  },
  async created() {
    await this.getData();
    this.actionListData = this.parsedPostsData?.[0];
  },
  mounted() {
    const images = Array.from(document.querySelectorAll("img")); // Select all images
    const videos = Array.from(document.querySelectorAll("video")); // Select all videos
    const mediaElements = [...images, ...videos];

    const loadPromises = mediaElements.map(
      (element) =>
        new Promise((resolve) => {
          if (element.complete || element.readyState > 0) {
            resolve(null);
          } else {
            element.addEventListener("load", () => resolve(null), {
              once: true,
            });
          }
        })
    );

    Promise.all(loadPromises).then(() => {
      this.loading = false;
    });

    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("resize", this.handleResize);

    this.width =
      document.body.clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth;
    if (this.width > 1024) {
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  methods: {
    changeTestimonial(t) {
      this.currentImage = t;
    },
    changeTestimonial2(t) {
      this.currentImage2 = t;
    },

    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick);
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
    },
    cursorOnClick: () => {},
    mouseMove(e) {
      if (this.width > 1024) {
        // this.xTo = e.pageX;
        // this.yTo = e.pageY;
        //
        this.xTo(e.pageX);
        this.yTo(e.pageY);
      }
    },
    handleScroll() {},
    handleResize() {
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
    search: function () {
      // clear timeout variable
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchQuery = this.value;
        this.getData();
      }, 1000);
    },
    async getData() {
      const config = useRuntimeConfig()
      const excludeCategories = config.public.MEMBERSHIP_ARTICLE_CATEGORIES.split(',');

      const query = gql`
  query CustomPages ($limit: Int) {
  posts(first: $limit, where: {withoutHidden: true, categoryNotIn: [${excludeCategories.join(',')}], notIn: [6677,6680], categoryName: "${
    this.activeFilter
  }", search: "${
    this.searchQuery
  }", language: ${this.$i18n.locale.toUpperCase()}}, ) {
    edges {
      node {
        id
        title

        date
        slug
        tags {
          nodes {
            name
          }
        }
        featuredImage {
          node {
            id
            mediaItemUrl
          }
        }
        blogConfig {
          perex
          content
        }
      }
    }
		pageInfo {
      hasPreviousPage
      endCursor
      hasNextPage
    }
  }
}

`;
      const { data } = await useAsyncQuery(query, {
        limit: this.currentPage * this.pageLimit,
      });
      this.featuredItemData = data;
      this.hasNextPage = data.value.posts?.pageInfo.hasNextPage;
      this.parsedPostsData = data.value.posts?.edges.map((p) => {
        return {
          id: p.node.id,
          title: p.node.title,
          content: p.node.blogConfig?.content,
          date: p.node.date,
          featuredImage: p.node.featuredImage?.node?.mediaItemUrl,
          perex: p.node.blogConfig?.perex,
          slug: p.node.slug,
        };
      });
      return this.data;
    },
  },
};
</script>

<style scoped lang="scss">
#cursor {
  position: absolute;
  top: 0;
  left: -10;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  border-radius: 50%;
  z-index: 1000;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}

.articles-page .bm-container {
  margin-top: 0px;
}

.active-tag {
  background-color: $color-primary;
  color: black;
  border: white;
}

select {
  display: block;
  //width: 100%;
  width: 135px;
  min-width: 135px;
  font-size: 1em;
  //padding: 0.8rem 0.5rem;
  //padding: 0 12px;
  border: 1px solid #333;
  font-family: inherit;
  /** for the dropdown indicator */
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;

  font-family: Roboto, sans-serif;

  option {
    font-family: Roboto, sans-serif;
    border-radius: 23px;
  }
  .select-selected {
    font-family: Roboto, sans-serif;
  }
}
</style>
